import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../context/AuthProvider';

/**
 * Rutas solo para invitados (login/registro).
 *
 * Si ya hay sesión respeta el destino pedido en `?next=` antes de caer al
 * inicio, evitando redirecciones circulares.
 */
export default function ProtectedRouteByNotUser({ children }) {
  const { user } = useAuthContext();
  const location = useLocation();

  if (!user) return children;

  const next = new URLSearchParams(location.search).get('next');

  return <Navigate to={next || '/'} replace />;
}
